<template>
  <div class="personal-inquiry-page">

    <!-- <div class="panel-group">
      <div class="panel panel-dev">
        <h3 class="panel-header">inquiryOrder</h3>
        {{inquiryOrder}}
        <hr>
        {{inquiryOrder.validate()}}
      </div>
    </div> -->

    <div class="panel-group">
      <div class="panel cargo-info">
        <h3 class="panel-header">货物信息</h3>
        <div class="panel-body">
          <div class="input-group">
            <label class="label">货物名称：</label>
            <input type="text" v-model="inquiryOrder.goodsName" class="input" placeholder="请输入货物名称">
          </div>
          <div class="input-group has-radio">
            <label class="label">货物重量：</label>
            <input type="number" v-model="inquiryOrder.goodsCount" class="input" placeholder="请输入货物重量">
            <div class="radio-group">
              <input type="radio" v-model="inquiryOrder.unit" value="吨" class="radio" name="unit" id="unit-dun">
              <label for="unit-dun">吨</label>
            </div>
            <div class="radio-group">
              <input type="radio" v-model="inquiryOrder.unit" value="方" class="radio" name="unit" id="unit-fang">
              <label for="unit-fang">方</label>
            </div>
          </div>
          <div class="input-group">
            <label class="label">货主姓名：</label>
            <input type="text" v-model="inquiryOrder.name" class="input" placeholder="请输入货主姓名">
          </div>
          <div class="input-group">
            <label class="label">电话号码：</label>
            <input type="number" v-model="inquiryOrder.phone" class="input" placeholder="请输入电话号码">
          </div>
          <div class="input-group">
            <label class="label">提货地址：</label>
            <!-- <input type="text" class="input" placeholder="请输入提货地址"> -->
            <v-distpicker @province="fromProvinceHandler" @city="fromCityHandler" @area="fromAreaHandler"></v-distpicker>
          </div>
          <div class="input-group">
            <label class="label">送达地址：</label>
            <!-- <input type="text" class="input" placeholder="请输入送达地址"> -->
            <v-distpicker @province="toProvinceHandler" @city="toCityHandler" @area="toAreaHandler"></v-distpicker>
          </div>
        </div>
      </div>
      <div class="panel inquiry-info">
        <h3 class="panel-header">发货信息</h3>
        <div class="panel-body">
          <span>是否货到付款：</span>
          <div class="radio-group">
            <input type="radio" value="是" class="radio" name="huodaofukuan" id="huodaofukuan-yes">
            <label for="huodaofukuan-yes">是</label>
          </div>
          <div class="radio-group">
            <input type="radio" value="否" class="radio" name="huodaofukuan" id="huodaofukuan-no">
            <label for="huodaofukuan-no">否</label>
          </div>
<br><br>
          <span>是否需要发票：</span>
          <div class="radio-group">
            <input type="radio" value="是" class="radio" name="fapiao" id="fapiao-yes">
            <label for="fapiao-yes">是</label>
          </div>
          <div class="radio-group">
            <input type="radio" value="否" class="radio" name="fapiao" id="fapiao-no">
            <label for="fapiao-no">否</label>
          </div>
        </div>
      </div>
    </div>


    <button class="btn btn-primary inquiry-btn" @click="inquiryHandler">立即询价</button>
  </div>
</template>

<script type="text/ecmascript-6">
  import InquiryOrder from '@/models/InquiryOrder';
  import qs from 'qs';

  export default {
    name: 'indexPage',
    data() {
      return {
        inquiryOrder: new InquiryOrder()
      }
    },
    methods: {
      fromProvinceHandler(data) {
        this.inquiryOrder.provinceFrom = data.code;
      },
      fromCityHandler(data) {
        this.inquiryOrder.cityFrom = data.code;
      },
      fromAreaHandler(data) {
        this.inquiryOrder.districtFrom = data.code;
      },
      toProvinceHandler(data) {
        this.inquiryOrder.provinceTo = data.code;
      },
      toCityHandler(data) {
        this.inquiryOrder.cityTo = data.code;
      },
      toAreaHandler(data) {
        this.inquiryOrder.districtTo = data.code;
      },

      // 开始立即询价
      inquiryHandler() {
        const invalid = this.inquiryOrder.validate();
        if (invalid.length > 0) {
          if(invalid[0].extraFail) {
            this.$alert(`请填写正确的 ${invalid[0].name}`, '询价失败', {
              confirmButtonText: '确定'
            });
            return;
          }
          this.$alert(`请填写 ${invalid[0].name}`, '询价失败', {
            confirmButtonText: '确定'
          });
          return;
        }

        this.$http.post('/shipper/order-inquiry/new-create', qs.stringify(this.inquiryOrder)).then(res => {
          this.$message({
            type: 'success',
            message: '询价成功，请等待工作人员与您联系!'
          });
        }).catch(err => {
          this.$message({
            type: 'error',
            message: '询价失败，'+err.message
          });
          console.error(err);
        });
      }
    },
    created() {

    }
  }

</script>

<style rel="stylesheet/scss" lang="scss">
  @import "../../style/_variable";

  .personal-inquiry-page {
    padding-top: 52px;

    .input-group {
      width: 49%;
      .input {
        width: 360px;
      }

      &.has-radio {
        .input {
          width: 240px;
        }
      }

      .address {
        width: 360px;
      }
    }

    .inquiry-btn {
      display: block;
      width: 364px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      margin: 0 auto;
      margin-top: 40px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/personal/inquiry.vue